import createReducer from "rdx/utils/createReducer";
import types from "rdx/types";

const initialState = {
  partnersListAutoComplete: {},
  partnersList: {
    paging: {
      pageSize: 50,
      pageNumber: 1,
      itemCount: 0,
    },
    list: [],
    labor: [],
    moduleOn: false,
  },
  recommendedPartners: [],
};

export default {
  preferredPartners: createReducer(initialState, {
    [types.SET_PREFERRED_PARTNERS_ADMIN](state, action) {
      return {
        ...state,
        enterprisesWithPartners: {
          ...state.enterprisesWithPartners,
          ...action.payload,
        },
      };
    },

    [types.SET_PREFERRED_PARTNERS_AUTOCOMPLETE_SUGGESTIONS](state, action) {
      const { key, suggestions } = action.payload;
      if (key) {
        return {
          ...state,
          partnersListAutoComplete: {
            ...state.partnersListAutoComplete,
            [key]: suggestions || [],
          },
        };
      }
      return state;
    },
    //   INSERTION_PT (for script, do not remove)
  }),
};
